const FooterDetialsItem = (props) => {
    return (
            <div className="boxItem" data-testid={props.testId}>
                <p
                  className='box_itemL'
                  dir="ltr"
                  data-testid={props.testId ? `${props.testId}-value` : undefined}
                >
                  {props.numeric}
                </p>
                <p
                  className='box_itemR'
                  data-testid={props.testId ? `${props.testId}-label` : undefined}
                >
                  {props.text}
                </p>
            </div>
    )
}
export default FooterDetialsItem;
